// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__2ekAg","navText":"Navbar_navText__3wlZG","navLogo":"Navbar_navLogo__3sb-q","imgLogo":"Navbar_imgLogo__M06fz"};